import $ from 'jquery'

export class OdooForm {

  constructor() {
    this.classes = {
      submitting: 'is-submitting',
      fieldError: 'is-error',
    }

    $(document).on('submit', 'form.odoo-form', this.handleSubmit.bind(this))
  }

  handleSubmit(e) {
    e.preventDefault()

    const $form = $(e.currentTarget)

    if ($form.hasClass(this.classes.submitting) || typeof odooForm === 'undefined') {
      return
    }

    this.clearErrors($form)
    $form.addClass(this.classes.submitting)

    const data = $form.serializeArray()
    data.push({name: 'action', value: odooForm.action})
    data.push({name: 'nonce', value: odooForm.nonce})

    $.ajax({
      url: odooForm.ajaxUrl,
      data: $.param(data),
      type: 'POST',
      dataType: 'json',
      success: (response) => this.handleSuccess($form, response),
      error: (jqXHR) => this.handleError($form, jqXHR),
      complete: () => $form.removeClass(this.classes.submitting),
    })
  }

  handleSuccess($form, response) {
    if (response && response.success) {
      if (response.data && response.data.redirect) {
        window.location.href = response.data.redirect
      }
      return
    }

    const data = response && response.data

    if (data && data.errors) {
      this.showFieldErrors($form, data.errors)
      return
    }

    this.showError($form, (data && data.message) || '')
  }

  /**
   * One message per invalid field (missing required, invalid email/mobile...),
   * shown directly under that field instead of the single form-level banner.
   */
  showFieldErrors($form, errors) {
    Object.keys(errors).forEach((name) => {
      const $field = $form.find(`[name="${name}"]`)
      const $container = $field.closest('.odoo-field')

      $field.addClass(this.classes.fieldError)
      $container.addClass(this.classes.fieldError)
      $container.find('.odoo-field-error').text(errors[name]).addClass('is-visible')
    })
  }

  /**
   * jQuery routes any non-2xx HTTP status to `error`, even though the server
   * (wp_send_json_error) still sends a proper JSON body with the real message
   * (missing field, invalid email...). Reuse handleSuccess's error handling
   * when that body is present; only show the generic network error when it's
   * a genuine network/parse failure with no JSON to read.
   */
  handleError($form, jqXHR) {
    if (jqXHR && jqXHR.responseJSON) {
      this.handleSuccess($form, jqXHR.responseJSON)
      return
    }

    this.showError($form, odooForm.errorNetwork || '')
  }

  showError($form, message) {
    const $error = $form.find('.odoo-form-error')

    if (!$error.length) {
      return
    }

    $error.text(message).toggleClass('is-visible', !!message)
  }

  clearErrors($form) {
    $form.find('.odoo-form-error, .odoo-field-error').text('').removeClass('is-visible')
    $form.find('.' + this.classes.fieldError).removeClass(this.classes.fieldError)
  }
}
